import Drawer from "src/shared/components/layout/drawer/Drawer"
import TabMenu from "src/shared/components/navigation/tab-menu/TabMenu"
import useComentariosMantenimiento from "./hooks/useComentariosMantenimiento"
import { mantenimientosDetailTabs } from "./MantenimientosDetail.constants"
import { MantenimientosDetailProps, MantenimientosDetailTab } from "./MantenimientosDetail.type"
import ComentariosTab from "./sections/ComentariosTab"
import InformacionGeneralTab from "./sections/InformacionGeneralTab"
import "./MantenimientosDetail.css"

const emptyValue = "-"

const MantenimientosDetail = ({
    isOpen,
    onClose,
    data,
    activeTab,
    onChangeTab,
}: MantenimientosDetailProps): JSX.Element => {
    const { comentarios, loading } = useComentariosMantenimiento({
        colaboradorTareaId: data?.colaborador_tarea_id,
        enabled: isOpen && activeTab === "comentarios",
    })

    // el subtítulo es el tipo de habitación con su número, sin diagonal entre ambos
    const habitacion = [data?.tipo_habitacion, data?.numero_habitacion].filter(Boolean).join(" ")

    return (
        <Drawer placement={"right"} bar={false} visible={isOpen} withCloseButton onClose={onClose} testId="mantenimientos-detail">
            <div className="mantto-detail__head">
                <p className="mantto-detail__title">Mantenimiento</p>
                <p className="mantto-detail__subtitle">{habitacion || emptyValue}</p>
            </div>
            <TabMenu
                className="mantto-detail__tabs"
                darkMode
                value={activeTab}
                tabList={mantenimientosDetailTabs}
                onChange={(value) => onChangeTab(value as MantenimientosDetailTab)}
            />
            <div className="mantto-detail__body">
                {activeTab === "general" ? (
                    <InformacionGeneralTab data={data} />
                ) : (
                    <ComentariosTab comentarios={comentarios} loading={loading} />
                )}
            </div>
        </Drawer>
    )
}

export default MantenimientosDetail
